<template>
  <div>
    <div
      v-if="display"
      persistent
      max-width="600">
      <div>
        <div>{{ displayTitle }}</div>
        <div>
          <template v-if="error">
            <p
              v-if="error.timestamp"
              class="mb-3">
              {{ error.timestamp }}
            </p>
            <p v-if="error.request && typeof error.response === 'undefined'">
              No response was received. This could be a CORS issue or dropped network connection.
            </p>
            <code v-if="error.stack">{{ error.stack }}</code>
          </template>
        </div>
        <div v-if="closeable">
          <div
            color="grey"
            flat
            @click="display = false">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const props = {
  title: {
    type: String,
    required: false,
  },
  error: {
    type: Object,
    required: false,
  },
  closeable: {
    type: Boolean,
    required: false,
  },
};

const computed = {
  displayTitle() {
    if (this.title) {
      return this.title;
    }
    return this.error ? this.error.message : "Error";
  },
};

export default {
  props,
  data() {
    return {
      display: true,
    };
  },
  computed,
};
</script>
